import { NextPage } from "next";
import { getGlobals } from "@models/globals.model";
import { Sanity } from "@models/sanity.model";
import AccountAuth from "@components/account-auth";

const AccountPage: NextPage<Sanity.PageProps> = ({ globals }) => {
  return (
    <AccountAuth globals={globals} pageID="account-page" seo={{ title: "Account | Information" }} />
  );
};

export default AccountPage;

export async function getStaticProps() {
  const [globals] = await Promise.all([await getGlobals()]);
  return {
    props: {
      globals,
    },
  };
}
